// extracted by mini-css-extract-plugin
export default {"featured":"FeaturedSection_featured__YwpEb","logos":"FeaturedSection_logos__EKBb5"};